import { render, staticRenderFns } from "./PublicProjectCommercialModels.vue?vue&type=template&id=bd12693c&"
import script from "./PublicProjectCommercialModels.vue?vue&type=script&lang=js&"
export * from "./PublicProjectCommercialModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports